import { en } from "./en";
import { cn } from "./cn";
import { hk } from "./hk";
import { ms } from "./ms";
import { fr } from "./fr";
import { es } from "./es";
import { de } from "./de";
import { jp } from "./jp";

export const localization = {
  en,
  cn,
  hk,
  ms,
  fr,
  es,
  de,
  jp
};
